import React from "react";
import {AppActions, useAppContext} from "../../context/AppContext";
import {Button, Table, Tabs, Tag, Typography} from "antd";
import AppColor from "../../components/AppColor";
import {CloseOutlined} from "@ant-design/icons";

export default function MessageSelect({type}) {
    const {appContext, dispatchProject, getSelectedHistory, selectedHistoryId, getHistorySorted, resolveHistorySelection} = useAppContext()
    // Histories store id-refs; resolve once per render so the JSX below can
    // read record.selection.base.project.modelType etc. as before.
    const resolveRec = (record) => resolveHistorySelection(record) || {base: {}, compare: {}}

    const selectHistory = (record) => {
        dispatchProject({
            type: AppActions.SET_SELECTED_HISTORY_ID,
            data: {id: record.id}
        })
    }

    const Tool = ({record}) => {
        return (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Button
                    type={'text'}
                    size={'small'}
                    icon={<CloseOutlined style={{fontSize: '8pt'}}/>}
                    onClick={() => {
                        const _history = appContext?.history?.filter(x => x.id !== record.id)
                        dispatchProject({
                            type: AppActions.SET_HISTORY,
                            data: {
                                history: _history
                            }
                        })
                    }}
                />
            </div>
        )
    }

    const onTabChange = (key) => {
        if(getSelectedHistory()?.type === 'Check' && key === 'Comparison') {
            const _histories = getHistorySorted()?.filter(x => x.type === 'Comparison')
            if(_histories?.length > 0) {
                dispatchProject({
                    type: AppActions.SET_SELECTED_HISTORY_ID,
                    data: {id: _histories[0]?.id}
                })
            }
        }

        if(getSelectedHistory()?.type === 'Comparison' && key === 'Check') {
            const _histories = getHistorySorted()?.filter(x => x.type === 'Check')
            if(_histories?.length > 0) {
                dispatchProject({
                    type: AppActions.SET_SELECTED_HISTORY_ID,
                    data: {id: _histories[0]?.id}
                })
            }
        }
    }

    return (
        <div style={{display: 'flex', alignItems: 'start'}}>
            <Tabs style={{width: '100%'}} activeKey={appContext?.history?.find(x => x.id === selectedHistoryId)?.type} onChange={onTabChange}>
                <Tabs.TabPane tab={'Check'} key={'Check'} disabled={getHistorySorted()?.filter(x => x.type === 'Check')?.length === 0}>
                    <Table
                        style={{width: '100%'}}
                        pagination={false}
                        size={'small'}
                        dataSource={getHistorySorted()?.filter(x => x.type === 'Check')}
                        rowKey={'id'}
                        columns={[
                            {
                                key: '7',
                                dataIndex: '7',
                                title: '#',
                                width: 50,
                                render: (text, record, index) => {
                                    let num = `-`
                                    if(index < 9)
                                        num = index+1;

                                    if(index === 9)
                                        num = 0

                                    return (
                                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                            <div>{num}</div>
                                            <Tool record={record}/>
                                        </div>
                                    )
                                }
                            },
                            {
                                key: '1',
                                dataIndex: '1',
                                title: 'Date',
                                width: 150,
                                render: (text, record) => new Date(record.date).toLocaleString()
                            },
                            {
                                key: '2',
                                dataIndex: '2',
                                title: 'Project',
                                render: (text, record) => (
                                    <Typography.Link
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            color: record.id === getSelectedHistory()?.id ? AppColor.mainColor : '',
                                            minWidth: 250
                                        }}
                                        onClick={() => selectHistory(record)}
                                    >
                                        <Tag>{resolveRec(record).base?.project?.modelType}</Tag>
                                        <span style={{fontWeight: record.id === getSelectedHistory()?.id ? 'bold' : ''}}>{resolveRec(record).base?.project?.information?.title?.trim()}</span>
                                    </Typography.Link>
                                )
                            },
                            {
                                key: '4',
                                dataIndex: '4',
                                title: 'Plan',
                                render: (text, record) => (
                                    <div style={{minWidth: 250}}>
                                        {resolveRec(record).base?.plan?.type}
                                    </div>
                                )
                            },
                            {
                                key: '5',
                                dataIndex: '5',
                                title: 'River - Reach',
                                render: (text, record) => (
                                    <div style={{minWidth: 250}}>
                                        {(record?.selection?.base?.river?.river) && (
                                            <>
                                                {record?.selection?.base?.river?.river} - {record?.selection?.base?.river?.reach}
                                            </>
                                        )}
                                        {!(record?.selection?.base?.river?.river) && (
                                            <>
                                                -
                                            </>
                                        )}
                                    </div>
                                )
                            },
                        ]}
                    />
                </Tabs.TabPane>
                <Tabs.TabPane tab={'Comparison'} key={'Comparison'} disabled={getHistorySorted()?.filter(x => x.type === 'Comparison')?.length === 0}>
                    <Table
                        style={{width: '100%'}}
                        pagination={false}
                        size={'small'}
                        dataSource={getHistorySorted()?.filter(x => x.type === 'Comparison')}
                        rowKey={'id'}
                        columns={[
                            {
                                align: 'top',
                                key: '7',
                                dataIndex: '7',
                                title: '#',
                                width: 50,
                                render: (text, record, index) => {
                                    let num = `-`
                                    if(index < 9)
                                        num = index+1;

                                    if(index === 9)
                                        num = 0

                                    return (
                                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                            <div>{num}</div>
                                            <Tool record={record}/>
                                        </div>
                                    )
                                }
                            },
                            {
                                align: 'top',
                                key: '1',
                                dataIndex: '1',
                                title: 'Date',
                                width: 150,
                                render: (text, record) => new Date(record.date).toLocaleString()
                            },
                            {
                                key: '2',
                                dataIndex: '2',
                                title: 'Project',
                                render: (text, record) => (
                                    <Typography.Link
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            color: 'black',
                                            minWidth: 250
                                        }}
                                        onClick={() => selectHistory(record)}
                                    >
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{color: record.id === getSelectedHistory()?.id ? AppColor.mainColor : ''}}>
                                                    <Tag>{resolveRec(record).base?.project?.modelType}</Tag>
                                                    <span style={{marginRight: 4, fontWeight: record.id === getSelectedHistory()?.id ? 'bold' : ''}}>{resolveRec(record).base?.project?.information?.title?.trim()}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{color: record.id === getSelectedHistory()?.id ? AppColor.mainColor : ''}}>
                                                    <Tag>{resolveRec(record).compare?.project?.modelType}</Tag>
                                                    <span style={{marginRight: 4, fontWeight: record.id === getSelectedHistory()?.id ? 'bold' : ''}}>{resolveRec(record).compare?.project?.information?.title?.trim()}</span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </Typography.Link>
                                )
                            },
                            {
                                key: '3',
                                dataIndex: '3',
                                title: 'Plan',
                                render: (text, record) => (
                                    <table style={{minWidth: 250}}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {resolveRec(record).base?.plan?.type}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {resolveRec(record).compare?.plan?.type}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                )
                            },
                            {
                                key: '4',
                                dataIndex: '4',
                                title: 'River - Reach',
                                render: (text, record) => (
                                    <table style={{minWidth: 250}}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {(record?.selection?.compare?.river?.river) ? `${record?.selection?.compare?.river?.river} - ${record?.selection?.compare?.river?.reach}` : '-'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {(record?.selection?.compare?.river?.river) ? `${record?.selection?.compare?.river?.river} - ${record?.selection?.compare?.river?.reach}` : '-'}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                )
                            },
                        ]}
                    />
                </Tabs.TabPane>
            </Tabs>
        </div>
    )
}